export const Lang = {
  title: 'Log out of St. Andrews Links',
  confirmation: 'Are you sure you want to log out?',
};
